import React from 'react';
import { YellowBoxBottom } from '../Pages/Home/Home';
import { Typography } from '@mui/material';

const JoinUsBox = () => {
  return (
    <YellowBoxBottom>
      <Typography variant="h2" gutterBottom fontWeight={600}>
        Join Us
      </Typography>
      <Typography variant="body1">
        Be part of a company that’s redefining intelligence for the next
        generation.
        <br />
        Bring your passion, your ideas, and your drive let's build the future
        together.
      </Typography>
    </YellowBoxBottom>
  );
};

export default JoinUsBox;
